import { useEffect, useRef, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import Div from "../../common/components/div";
import { EnterEmail } from "./EnterEmail";
import { SelectEmail } from "./SelectEmail";
import { EnterPhone } from "./EnterPhone";
import { SecurityCodeMethod, useMfaApi } from "../hooks/useMfaApi";
import useCheckForSession from "../../common/hooks/useCheckForSession";
import { FullPageSpinner } from "../../common/components/FullPageSpinner";
import { useMfaPageView } from "../../common/hooks/use.analytics";
import translate from "../../common/functions/translate";
import { usePageTitle } from "../../common/hooks/usePageTitle";
import BackNav from "../../common/components/BackNav";
import { useSetConfigurationOptions } from "../../common/hooks/useSetConfigurationOptions";

export interface EnterYourInfoProps {
    type: SecurityCodeMethod
    value?: string
    flow: 'add' | 'enroll'
}

export const EnterYourInfo = () => {
    const location = useLocation<EnterYourInfoProps>();
    const { type, flow } = location.state;
    const [email, setEmail] = useState<string | null>(null);
    const [isCheckingSession, setIsCheckingSession] = useState(true);
    const [isLoadingEmail, setIsLoadingEmail] = useState(type === 'email');
    const loadRef = useRef(false);
    const history = useHistory();
    const api = useMfaApi();
    const configurationOptions = useSetConfigurationOptions();
    usePageTitle(translate(`mfa_title_${flow}`));
    useMfaPageView(flow, `${type} security code`);
    useCheckForSession(setIsCheckingSession);

    useEffect(() => {
        if (loadRef.current || type !== 'email') {
            return;
        }
        getEmail();

        async function getEmail() {
            loadRef.current = true;
            const getUserEmailResponse = await api.mfaEnrollGetEmail();
            if (getUserEmailResponse?.data.email && getUserEmailResponse?.status === 200) {
                setEmail(getUserEmailResponse?.data.email);
            }
            setIsLoadingEmail(false);
        }
    }, [api, history, type]);

    if (isCheckingSession || isLoadingEmail) {
        return <FullPageSpinner />
    }

    const isMethodUsed = configurationOptions?.some(option => option.mfa_channel === email);
    const showSelectEmail = email && !isMethodUsed;
    const emailComponent = showSelectEmail ? <SelectEmail value={email} flow={flow} /> : <EnterEmail flow={flow}/>

    return (<>
        <BackNav />
        <Div isContainer paddingy={1} paddingyMD={2}>
            <Div isRow>
                <Div cols={12}>
                    {type === 'email' && emailComponent}
                    {type === 'sms' && <>
                        <EnterPhone type="sms" flow={flow}/>
                    </>}
                    {type === 'voice' && <>
                        <EnterPhone type="voice" flow={flow}/>
                    </>}
                </Div>
            </Div>
        </Div>
    </>);
}